import { AccessPath } from "@intentsify/authorization";
import { UserAuditLogScreen } from "types";
import { createScreen } from "utils/createScreen";

export const USER_AUDIT_LOG_ACCESS_PATH = "user.auditLog" as AccessPath;

export const UserAuditLogScreenDefinition = {
  ...createScreen({
    name: UserAuditLogScreen,
    path: "/admin/user-audit-log",
    routePath: ["user-audit-log"],
  }),
  accessPath: USER_AUDIT_LOG_ACCESS_PATH,
};
